import { Component, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { Event } from '../../models/event.model';
import { EventsService } from '../../services/events.service';

export type DeleteEventResult = 'success' | 'cancel' | 'error';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  imports: [DatePipe, BoDialogComponent, ButtonComponent],
})
export class DeleteComponent {
  private dialogRef = inject<BrnDialogRef<DeleteEventResult>>(BrnDialogRef);
  private eventsService = inject(EventsService);

  readonly data = input.required<Event>();

  private waitingApi = false;

  public onDismiss() {
    this.dialogRef.close('cancel');
  }

  public onConfirm(id: number) {
    if (this.waitingApi) return;
    this.waitingApi = true;

    this.eventsService.removeEventOnDb(id).subscribe({
      next: () => this.dialogRef.close('success'),
      error: () => this.dialogRef.close('error'),
    });
  }
}
